import { createFileRoute, useRouterState } from '@tanstack/react-router';

import { SourceClientPage } from '../../pages/sources';
import { useSession } from '../../entities/session';
import { listReturnQ } from '../../shared/lib/list-return';

export const Route = createFileRoute('/_shell/sources/$sourceId/clients/$customerId')({
  component: function SourceClientRoute() {
    const { sourceId, customerId } = Route.useParams();
    const listQ = useRouterState({ select: (state) => listReturnQ(state.location.state) });
    const session = useSession();

    return (
      <SourceClientPage
        key={customerId}
        sourceId={sourceId}
        customerId={customerId}
        listQ={listQ}
        timeZone={session.data?.preferences.timezone}
      />
    );
  },
});
